import { useState } from "react";
import { useImpersonation } from "../../contexts/useSuperuser";

/**
 * Persistent banner shown while a superuser is impersonating a role.
 *
 * Distinct from the (orange) user-impersonation banner: role impersonation
 * keeps the superuser's identity, so the messaging and colour differ. The two
 * sessions are not used together in practice.
 */
export default function RoleImpersonationBanner() {
  const { impersonatedRole, stopRoleImpersonation } = useImpersonation();
  const [exiting, setExiting] = useState(false);

  if (!impersonatedRole) return null;

  const handleExit = async () => {
    setExiting(true);
    try {
      await stopRoleImpersonation();
    } finally {
      setExiting(false);
    }
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] bg-[#4f46e5] text-white px-4 py-2 flex items-center justify-between gap-4 font-semibold text-sm shadow-md">
      <span className="flex items-center gap-4 flex-wrap">
        <span>
          Viewing as role: <strong>{impersonatedRole}</strong>
        </span>
        <span className="text-[11px] font-extrabold tracking-wider bg-black/25 px-2 py-0.5 rounded-sm">
          PERMISSIONS REFLECT THIS ROLE, NOT YOUR OWN.
        </span>
      </span>
      <button
        onClick={handleExit}
        disabled={exiting}
        className="bg-white/25 border border-white/60 text-white px-3 py-1 rounded cursor-pointer font-semibold text-[13px] whitespace-nowrap shrink-0 disabled:opacity-60"
      >
        {exiting ? "Exiting…" : "Exit Role Impersonation"}
      </button>
    </div>
  );
}
